import antdData from 'antd/locale/en_US'

const messages = {
  'topBar.profileMenu.hello': 'Hello',
  'topBar.profileMenu.role': 'Role(s)',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Phone',
  'topBar.profileMenu.refresh': 'Refresh',
  'topBar.profileMenu.logout': 'Logout',

  'datatable.search': 'Search...',
  'datatable.actions.refresh': 'Refresh',
  'datatable.tooltips.clear': 'Clear all filters',
  'datatable.tooltips.refresh': 'Reload using current filters',
  'datatable.tooltips.columns': 'Toggle column visibility',
  'datatable.tooltips.export': 'Export',

  // business specific
  'createOrder.menu.title': 'Create Order',
  'createOrder.menu.title.fast': 'Create Order Fast',
  'createOrder.car_class': 'Car class',
  'createOrder.phone': 'Phone',
  'createOrder.name': 'Name',
  'createOrder.obs': 'Obs',
  'createOrder.street_no': 'No',
  'createOrder.block': 'Block',
  'createOrder.entrance': 'Entrance',
  'createOrder.pickup': 'Pickup',
  'createOrder.dropoff': 'Dropoff',
  'createOrder.send': 'Send',
  'createOrder.send_scheduled': 'Send scheduled',
  'createOrder.cancel': 'Cancel',
  'createOrder.employee': 'Employee',
  'dashboard.menu.title': 'Orders',
  'dashboard.recent_trips': 'Recent trips',
  'dashboard.create_account.message': "It seems you don't have a business account yet, so go ahead and create one now!",
  'dashboard.create_account.action': 'Create business account',
  'common.trips_list.filters.all_people': 'All people',
  'common.trips_list.filters.select_people': 'Select employee',
  'common.trips_list.columns.date_time': 'Date & Time',
  'common.trips_list.columns.person': 'Person',
  'common.trips_list.columns.driver': 'Driver',
  'common.trips_list.columns.status': 'Status',
  'common.trips_list.columns.pickup': 'Pickup',
  'common.trips_list.columns.dropoff': 'Dropoff',
  'common.trips_list.columns.cost': 'Cost',
  'common.trips_list.columns.comment': 'Comment',
  'common.trip_details.pickup': 'Pickup',
  'common.trip_details.dropoff': 'Dropoff',
  'common.trip_details.pass': 'Pass',
  'common.trip_details.driver': 'Driver',
  'common.trip_details.car': 'Car',
  'common.trip_details.class': 'Class',
  'common.trip_details.duration': 'Duration',
  'common.trip_details.download_receipt': 'Download receipt',
  'common.trip_details.code': 'Code',
  'common.notifications.done': 'Done!',
  'upcomings.menu.title': 'Upcomings',
  'upcomings.recent_trips': 'Upcomings',
  'upcomings.create_upcoming.message': "It seems you don't have an upcoming yet, so go ahead and create one now!",
  'upcomings.create_upcoming.action': 'Create upcoming',
  'upcomings.import.action': 'Import upcomings',
  'upcomings.import.uploading': 'Your file is being uploaded ...',
  'upcomings.import.success': 'Your file has been uploaded',
  'upcomings.import.error': 'error',
  'upcomings.import_ex.action': 'Import example',
  'people.menu.title': 'Employees',
  'people.trip_history': 'Trip history',
  'people.actions.add': 'Add employee',
  'people.actions.view': 'View',
  'people.actions.remove': 'Remove',
  'people.actions.save': 'Save',
  'people.actions.edit': 'Edit',
  'people.columns.name': 'Name',
  'people.columns.first_name': 'First name',
  'people.columns.last_name': 'Last name',
  'people.columns.job': 'Job title',
  'people.columns.phone': 'Phone',
  'people.columns.labels': 'Labels',
  'people.columns.status': 'Status',
  'people.columns.actions': 'Actions',
  'people.placeholders.first_name': 'First name (ex. John)',
  'people.placeholders.last_name': 'Last name (ex. Smith)',
  'people.placeholders.job': 'Ex. CEO',
  'people.placeholders.phone': 'Ex. +40723456789',
  'people.placeholders.labels': 'Ex. Executives, VPs',
  'people.placeholders.status': 'Select status',
  'people.placeholders.status.actve': 'active',
  'people.placeholders.status.disabled': 'disabled',
  'people.notifications.added': 'Person added.',
  'people.notifications.updated': 'Person updated.',
  'people.notifications.removed': 'Person removed.',
  'invites.menu.title': 'Invite codes',
  'invites.actions.add': 'Add invite',
  'invites.actions.view': 'View',
  'invites.actions.remove': 'Remove',
  'invites.actions.save': 'Save',
  'invites.actions.edit': 'Edit',
  'invites.actions.download': 'Download',
  'invites.columns.code': 'Code',
  'invites.columns.pin': 'PIN',
  'invites.columns.people': 'People',
  'invites.columns.actions': 'Actions',
  'invites.actions.manage': 'Manage',
  'invites.placeholders.code': 'Ex. NHTD8S',
  'invites.placeholders.pin': 'Ex. 8352',
  'invites.pages.edit.title': 'Invite details',
  'invites.notifications.added': 'Invite added.',
  'invites.notifications.updated': 'Invite updated.',
  'invites.notifications.removed': 'Invite removed.',
  'settings.menu.title': 'Settings',
  'settings.menu.labels': 'Labels',
  'settings.menu.rules': 'Rules',
  'settings.menu.account': 'Account',
  'settings.menu.account_edit': 'Edit account',
  'settings.menu.account_create': 'Create new account',
  'settings.rules.general': 'General rule',
  'settings.rules.users': 'Users rules',
  'settings.rules.car_class': 'Car class',
  'settings.rules.limit': 'Limit',
  'settings.rules.user': 'Employee',
  'settings.rules.actions.add': 'Add rule',
  'settings.rules.columns.id': 'ID',
  'settings.rules.columns.name': 'Name',
  'settings.rules.columns.limit': 'Limit',
  'settings.rules.columns.car_class': 'Car Class',
  'settings.rules.columns.user': 'Employee',
  'settings.rules.placeholders.name': 'Name',
  'settings.rules.placeholders.limit': 'Limit',
  'settings.rules.placeholders.car_class': 'Car Class',
  'settings.labels.actions.add': 'Add label',
  'settings.labels.actions.view': 'View',
  'settings.labels.actions.remove': 'Remove',
  'settings.labels.actions.save': 'Save',
  'settings.labels.actions.edit': 'Edit',
  'settings.labels.columns.name': 'Name',
  'settings.labels.columns.people': 'People',
  'settings.labels.columns.actions': 'Actions',
  'settings.labels.placeholders.name': 'Ex. Employees',
  'settings.labels.pages.edit.title': 'Edit label',
  'settings.labels.notifications.added': 'Label added.',
  'settings.labels.notifications.updated': 'Label updated.',
  'settings.labels.notifications.removed': 'Label removed.',
  'settings.account.sections.general': 'General',
  'settings.account.sections.legal': 'Legal information',
  'settings.account.sections.bank': 'Bank information',
  'settings.account.sections.representative': 'Representative information',
  'settings.account.sections.location': 'Location',
  'settings.account.columns.name': 'Account name',
  'settings.account.columns.region': 'Region',
  'settings.account.columns.legal_name': 'Legal name',
  'settings.account.columns.legal_office_address': 'Physical address',
  'settings.account.columns.legal_address': 'Legal address',
  'settings.account.columns.legal_idno': 'IDNO number',
  'settings.account.columns.legal_vat': 'VAT number',
  'settings.account.columns.legal_country': 'Country',
  'settings.account.columns.bank_iban': 'IBAN number',
  'settings.account.columns.bank_name': 'Bank name',
  'settings.account.columns.bank_code': 'Bank code',
  'settings.account.columns.bank_billing_address': 'Bank billing address',
  'settings.account.columns.location_name': 'Address',
  'settings.account.columns.location_position': 'Location',
  'settings.account.columns.representative_name': 'Name',
  'settings.account.columns.representative_position': 'Position',
  'settings.account.columns.representative_email': 'Email address',
  'settings.account.columns.representative_phone': 'Phone number',
  'settings.account.placeholders.name': 'ex. Mega Outlet Shop',
  'settings.account.placeholders.legal_name': 'ex. SC Mega Outlet Shop SRL',
  'settings.account.actions.create': 'Create account',
  'settings.account.actions.save': 'Save',
  'settings.account.create.title': 'Create a business account',
  'settings.account.edit.title': 'Edit business account',
  'settings.account.notifications.created': 'Account created.',
  'settings.account.notifications.updated': 'Account updated.',
  'finance.menu.title': 'Finance',
  'finance.menu.transactions': 'Transactions',
  'finance.menu.billing': 'Billing',
  'billing.menu.title': 'Transactions',
  'billing.balance': 'Balance',
  'billing.topup': 'Topup',
  'billing.balance_limit': 'Balance limit',
  'billing.balance_limit_description':
    'Please top up your account before this limit is exceeded - if the balance is negative (below the limit) the provision of taxi services will be automatically suspended.',
  'billing.filters.type': 'All types',
  'billing.columns.type': 'Type',
  'billing.columns.order': 'Order',
  'billing.columns.date_time': 'Date & Time',
  'billing.columns.amount': 'Amount',
  'billing.topup.transaction_type': 'Type',
  'billing.topup.card': 'Card',
  'billing.topup.cash': 'Cash',
  'billing.topup.amount': 'Amount',
  'billing.topup.description': 'Description',
  'cards.menu.title': 'Cards',
  'cards.list': 'Cards',
  'cards.add': 'Add card',
  'accounts.select_company': 'Select company',
}

const en = {
  locale: 'en',
  antdData,
  messages,
}

export default en
